import { Injectable } from '@angular/core';

@Injectable()
export class Libro
{
  public id: number = 0;
  public titulo: string = '';
  public descripcion: string = '';
  public autor: string = '';
  public editorial: string = '';
  public categoria_id: number = -1;
  public formato: string = 'E-book';
  public link: string = '';
  public estado: boolean = true;

  constructor() 
  { 
  }

  limpiarVariables()
  {
    this.id = 0;
    this.titulo = '';
    this.descripcion = '';
    this.autor = '';
    this.editorial = '';
    this.categoria_id = -1;
    this.formato = 'E-book'
    this.link = '';
    this.estado = true;
  }
}
